import {
    type UpdateRequestForEditCompanyResponseType,
    type UpdateRequestForEditCompanyRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const UpdateRequestForEditCompany = async (params: UpdateRequestForEditCompanyRequestType): Promise<UpdateRequestForEditCompanyResponseType> => {
    return await axios(`${SERVER_ADDRESS}/profile/updateRequestForEditCompany`, {
        method: "POST",
        headers: getHeaders(true),
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default UpdateRequestForEditCompany;
